import React from 'react';
import { FlexView } from '@cuemath/comps';
import { Button, Dropdown, Separator, Text } from '@cuemath/web-comps';
import LAYOUT from 'constants/layout';
import useNotGoodMatchLogic from './ResultNotAGoodMatch.logic';
import PropTypes from 'prop-types';
import ResultSuccess from '../result-success';

const { GUTTER } = LAYOUT;

const ResultNotAGoodMatch = ({
  result,
  showOtherTeachers,
  setShowOtherTeachers,
  dateTimePreset,
  filters,
  prospectId,
}) => {
  const { teachers } = result ?? {};
  const otherTeachers = teachers.length > 1 ? teachers.slice(1) : [];
  const {
    reason,
    setReason,
    handleSubmit,
    isBusy,
    options,
    submitSuccess,
  } = useNotGoodMatchLogic({
    prospectId,
    otherTeachers,
    showOtherTeachers,
    setShowOtherTeachers,
  });
  return (
    <FlexView>
      {submitSuccess && showOtherTeachers ? (
        <ResultSuccess
          mappingSearchResult={result}
          showOtherTeachers={showOtherTeachers}
          setShowOtherTeachers={setShowOtherTeachers}
          dateTimePreset={dateTimePreset}
          filters={filters}
          prospectId={prospectId}
        />
      ) : (
        <>
          {options?.length >= 0 && Array.isArray(options) ? (
            <>
              <Text variant="body1Regular">
                Not a good match? Please provide more details.
              </Text>
              <Separator height={GUTTER / 2} />
              <Dropdown
                label="Select a reason"
                options={options}
                onChange={selected => setReason(selected)}
                value={reason}
                width="100%"
                optionsWidth="90%"
                type="primary"
                height="fit-content"
                placeholder="Reason"
              />
              <Separator height={GUTTER * 3} />
              <FlexView alignItems="center">
                <Button
                  isDisabled={!reason}
                  isBusy={isBusy}
                  label={!showOtherTeachers ? 'Show other teachers' : 'Submit'}
                  size="small"
                  onClick={() => handleSubmit(prospectId)}
                />
              </FlexView>
            </>
          ) : (
            'Loading...'
          )}
        </>
      )}
    </FlexView>
  );
};

ResultNotAGoodMatch.propTypes = {
  mappingId: PropTypes.string,
};

export default ResultNotAGoodMatch;
